import { useEffect, useState } from "react";
import { Card, Space, Select, InputNumber, Switch, Button, Typography, Form, Input } from "antd";
import { useNotify } from "../../hooks/useNotify";

const API = (import.meta as any).env?.VITE_API_BASE_URL || "http://localhost:8001";

async function http<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { ...init, headers: { 'Content-Type': 'application/json', ...(init?.headers||{}) } });
  if (!res.ok) throw new Error(`${res.status}: ${await res.text()}`);
  return res.json();
}

export default function ResponseSettingsPage(){
  const notify = useNotify();
  const [brand, setBrand] = useState("Art-Visage");
  const [source, setSource] = useState("wildberries_cab1");
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState<string[]>([]);
  const [form] = Form.useForm();

  // Загрузка списка брендов
  useEffect(() => {
    http<{brands: string[]}>(`${API}/api/v1/reviews/brands`)
      .then(res => setBrands(res.brands || []))
      .catch(() => setBrands(["Art-Visage", "Estrade"])); // fallback
  }, []);

  const load = async ()=>{
    setLoading(true);
    try{
      const data = await http<any>(`${API}/api/v1/settings/response?brand=${encodeURIComponent(brand)}&source=${encodeURIComponent(source)}`);
      form.setFieldsValue({
        default_style: data.default_style,
        auto_publish_stars: (data.auto_publish_stars||[]).join(','),
        ignore_question_mark: data.ignore_question_mark,
        process_archived_days: data.process_archived_days,
        recommendation_policy: data.recommendation_policy,
      });
    }catch(e:any){ notify.error('Ошибка', e.message||String(e)); }
    finally{ setLoading(false); }
  };

  useEffect(()=>{ load(); }, [brand, source]);

  const save = async ()=>{
    try{
      const v = await form.validateFields();
      const stars = String(v.auto_publish_stars||'').split(',').map((s:string)=>parseInt(s.trim(),10)).filter((n:number)=>!Number.isNaN(n));
      const payload = {
        brand, source,
        default_style: v.default_style || null,
        auto_publish_stars: stars.length? stars : null,
        ignore_question_mark: !!v.ignore_question_mark,
        process_archived_days: v.process_archived_days ?? 0,
        delay_rules: null,
        recommendation_policy: v.recommendation_policy || 'off',
      };
      await http(`${API}/api/v1/settings/response`, { method:'PUT', body: JSON.stringify(payload)});
      notify.success('Сохранено');
    }catch(e:any){ notify.error('Ошибка', e.message||String(e)); }
  };

  return (
    <Space direction="vertical" style={{ width:'100%'}} size={16}>
      <Card title="Настройки ответов (по бренду/источнику)" loading={loading} extra={<Space>
        <Select value={brand} onChange={setBrand} style={{ width:200 }} options={brands.map(b => ({value: b, label: b}))} />
        <Select value={source} onChange={setSource} style={{ width:220 }} options={["wildberries_cab1","wildberries_cab2","ozon","excel_import"].map(v=>({value:v,label:v}))} />
      </Space>}>
        <Form form={form} layout="vertical">
          <Form.Item label="Стиль по умолчанию" name="default_style">
            <Select allowClear options={["профессиональный","заботливый","дружелюбный","серьёзный","шутливый","молодёжный","болтливый","оригинальный","позитивный","ободряющий"].map(v=>({value:v,label:v}))} />
          </Form.Item>
          <Form.Item label="Автопубликация (звезды через запятую)" name="auto_publish_stars">
            <Input placeholder="например 4,5" />
          </Form.Item>
          <Form.Item label="Игнорировать вопросительный знак" name="ignore_question_mark" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Обрабатывать архивные (дней)" name="process_archived_days">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label="Политика рекомендаций" name="recommendation_policy">
            <Select options={[{value:'off',label:'off'},{value:'soft',label:'soft'},{value:'aggressive',label:'aggressive'}]} />
          </Form.Item>
        </Form>
        <Space>
          <Button type="primary" onClick={save}>Сохранить</Button>
          <Button onClick={load}>Обновить</Button>
        </Space>
      </Card>
    </Space>
  )
}

